/**
 * 定时器相关，用于定时删除消息等
 * clear 应仅在 app 销毁前调用
 */

class Timer {
    constructor () {
        this.queue = new Map()
    }
    add (timeout, handler) {
        const id = setTimeout(handler, timeout)
        this.queue.set(id, id)
        return id
    }
    remove (id) {
        clearTimeout(id)
        this.queue.delete(id)
    }

    clear () {
        this.queue.forEach(id => {
            clearTimeout(id)
            this.remove(id)
        })
    }
}

export default new Timer
